import React from 'react';
import PropTypes from 'prop-types';
import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';
import messages from '../../lib/messages.js';
import ovalIcon from './oval.svg';

const BitOvalComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.oval}
    imgSrc={ovalIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="C"
  />
);

BitOvalComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default BitOvalComponent;
